import { useCallback, useRef } from 'react';

const normalizeStyles = (styles) => {
  if (!styles) return '';
  else if (typeof styles === 'object') return styleToString(styles);
  else return String(styles);
};

const styleToString = (style) => {
  return Object.entries(style)
    .map(([a, b]) => {
      return [
        a.split(/(?=[A-Z])/).join('-').toLowerCase(),
        b,
      ].join(':');
    })
    .join(';');
};

const getPrintCSS = (styles) => `
  @media print {
    @page {
      size: auto;
      margin: 0;
      ${styles.page || ''}
    }

    body {
      visibility: hidden;
    }

    .print-content {
      visibility: visible;
      position: absolute;
      inset: 0;
      z-index: 999;
      ${styles.content || ''}
    }
  }
`;

const triggerPrint = (node, documentTitle = '', styles = {}) => {
  const head = document.head || document.getElementsByTagName('head')[0];
  const prevDocumentTitle = document.title;
  const printStyles = document.createElement('style');

  printStyles.appendChild(document.createTextNode(getPrintCSS({
    page: normalizeStyles(styles.page),
    content: normalizeStyles(styles.content),
  })));
  
  if (documentTitle) {
    document.title = documentTitle;
  }
  
  head.appendChild(printStyles);
  node.classList.add('print-content');
  window.print();
  node.classList.remove('print-content');
  head.removeChild(printStyles);

  if (documentTitle) {
    document.title = prevDocumentTitle;
  }
};

const usePrint = (opts = {}) => {
  const ref = useRef(null);
  const { styles = {}, onBeforePrint, onAfterPrint, documentTitle } = opts;
  
  const handlePrint = useCallback(() => {
    if (ref.current) {
      if (typeof onBeforePrint === 'function') {
        onBeforePrint();
      }
      triggerPrint(ref.current, documentTitle, styles);
      if (typeof onAfterPrint === 'function') {
        onAfterPrint();
      }
    }
  }, [ref, styles, documentTitle, onBeforePrint, onAfterPrint]);
  
  return { ref, handlePrint };
};

export default usePrint;